import { FC } from 'react';
import { NavLink, Outlet } from 'react-router-dom';

import { useUserProfileApi } from '@/api/users';
import { FlexCol } from '@/components/ui/flex';
import { settingsPaths } from '@/paths';
import { cn } from '@/utils/classUtils';
import { Loader2 } from 'lucide-react';

const sidebarItems = [
  { name: 'My account', href: settingsPaths.myAccount },
  { name: 'Company profile', href: settingsPaths.companyProfile },
  { name: 'Subscriptions', href: settingsPaths.subscriptions },
  { name: 'Integrations', href: settingsPaths.integrations },
];

export const SettingsLayout: FC = () => {
  const { isLoading } = useUserProfileApi();

  if (isLoading) {
    return (
      <FlexCol alignItems="center" justifyContent="center" className="flex-1">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </FlexCol>
    );
  }

  return (
    <div className="flex h-full w-full flex-col">
      {/* Page title */}
      <div className="shrink-0 border-b border-border px-8 py-4">
        <h1 className="text-base font-medium text-foreground">Settings</h1>
      </div>

      <div className="flex flex-1 min-h-0">
        {/* Left sidebar */}
        <nav className="w-[200px] shrink-0 border-r border-border bg-[#fdfefc] px-3 py-4">
          <FlexCol gap="0.5">
            {sidebarItems.map(item => (
              <NavLink
                key={item.name}
                to={item.href}
                end
                className={({ isActive }) =>
                  cn(
                    'rounded-lg px-3 py-2 text-sm transition-colors',
                    isActive
                      ? 'bg-neutral-100 font-medium text-foreground'
                      : 'font-normal text-muted-foreground hover:bg-neutral-50 hover:text-foreground'
                  )
                }
              >
                {item.name}
              </NavLink>
            ))}
          </FlexCol>
        </nav>

        {/* Main content */}
        <div className="flex-1 overflow-y-auto">
          <div className="max-w-[1100px] p-8">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
